import {IAmplitudeLeadFormTrackingContext} from "../../types/lead/IAmplitudeLeadFormEventTracking";
import {ApplicationSource, ApplicationSourceSection} from "../../utils/form/application_form_source";
import {getAmplitudeFormLocation} from "./get_amplitude_form_location";
import {getAmplitudeInquirySource} from "./get_amplitude_inquiry_source";
import {getAmplitudeLeadFormInquiryTopics} from "./get_amplitude_lead_form_inquiry_topics";
import {getAmplitudeLeadFormProducts, IAmplitudeLeadFormProductData} from "./get_amplitude_lead_form_products";
import {getAmplitudeLeadType} from "./get_amplitude_lead_type";

export interface IGetAmplitudeLeadFormStartEventPropertiesParams {
    trackingContext: IAmplitudeLeadFormTrackingContext;
    leadData: IAmplitudeLeadFormProductData | IAmplitudeLeadFormProductData[] | undefined;
    source: ApplicationSource;
    sourceSection: ApplicationSourceSection;
    eventAction?: "autofill" | "manual_fill";
}

export const getAmplitudeLeadFormStartEventProperties = (params: IGetAmplitudeLeadFormStartEventPropertiesParams) => {
    const {trackingContext, leadData, source, sourceSection, eventAction} = params;
    const products = getAmplitudeLeadFormProducts(leadData);
    const primaryLeadData = Array.isArray(leadData) ? leadData[0] : leadData;
    const inquiryTopics = trackingContext.inquiry_topics ?? getAmplitudeLeadFormInquiryTopics(source);

    return {
        inquiry_source: getAmplitudeInquirySource(source),
        cta_text: trackingContext.cta_text,
        form_location: getAmplitudeFormLocation(primaryLeadData, trackingContext.form_location),
        source_id: trackingContext.source_id,
        lead_type: getAmplitudeLeadType(sourceSection),
        inquiry_topics: inquiryTopics,
        products,
        ...(eventAction ? {event_action: eventAction} : {}),
        ...(trackingContext.promotion_id != null && {promotion_id: trackingContext.promotion_id}),
        ...(trackingContext.creative_name && {creative_name: trackingContext.creative_name}),
        ...(trackingContext.promotion_name && {promotion_name: trackingContext.promotion_name}),
        ...(trackingContext.promotion_content && {promotion_content: trackingContext.promotion_content}),
        ...(trackingContext.auth_placement !== undefined && {auth_placement: trackingContext.auth_placement})
    };
};
import {IAmplitudeLeadFormTrackingContext} from "../../types/lead/IAmplitudeLeadFormEventTracking";
import {ApplicationSource, ApplicationSourceSection} from "../../utils/form/application_form_source";
import {getAmplitudeFormLocation} from "./get_amplitude_form_location";
import {getAmplitudeInquirySource} from "./get_amplitude_inquiry_source";
import {getAmplitudeLeadFormInquiryTopics} from "./get_amplitude_lead_form_inquiry_topics";
import {getAmplitudeLeadFormProducts, IAmplitudeLeadFormProductData} from "./get_amplitude_lead_form_products";
import {getAmplitudeLeadType} from "./get_amplitude_lead_type";

export interface IGetAmplitudeLeadFormStartEventPropertiesParams {
    trackingContext: IAmplitudeLeadFormTrackingContext;
    leadData: IAmplitudeLeadFormProductData | IAmplitudeLeadFormProductData[] | undefined;
    source: ApplicationSource;
    sourceSection: ApplicationSourceSection;
    eventAction?: "autofill" | "manual_fill";
}

export const getAmplitudeLeadFormStartEventProperties = (params: IGetAmplitudeLeadFormStartEventPropertiesParams) => {
    const {trackingContext, leadData, source, sourceSection, eventAction} = params;
    const products = getAmplitudeLeadFormProducts(leadData);
    const primaryLeadData = Array.isArray(leadData) ? leadData[0] : leadData;
    const inquiryTopics = trackingContext.inquiry_topics ?? getAmplitudeLeadFormInquiryTopics(source);

    return {
        inquiry_source: getAmplitudeInquirySource(source),
        cta_text: trackingContext.cta_text,
        form_location: getAmplitudeFormLocation(primaryLeadData, trackingContext.form_location),
        source_id: trackingContext.source_id,
        lead_type: getAmplitudeLeadType(sourceSection),
        inquiry_topics: inquiryTopics,
        products,
        ...(eventAction ? {event_action: eventAction} : {}),
        ...(trackingContext.promotion_id != null && {promotion_id: trackingContext.promotion_id}),
        ...(trackingContext.creative_name && {creative_name: trackingContext.creative_name}),
        ...(trackingContext.promotion_name && {promotion_name: trackingContext.promotion_name}),
        ...(trackingContext.promotion_content && {promotion_content: trackingContext.promotion_content}),
        ...(trackingContext.auth_placement !== undefined && {auth_placement: trackingContext.auth_placement})
    };
};
